import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import { getBookmarkCandidates } from "../../actions/bookmarkCandidates";
import {
  bookmarkCandidate,
  removeBookmarkCandidate,
} from "../../api/bookmarkCandidates";
import { apiErrorHandler } from "../common";
import { CustomSnackbar } from "../CustomSnackbar";






const AddToBookmarkCandidate = ({
  candidateId,
  showIcon = true,
  showText = false,

}) => {
  const customer = useSelector((state) => state.customer.profile);

  const bookmarkCandidates = useSelector(
    (state) => state.bookmarkCandidates.data
  );

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const findBookmarkedCandidate =
    bookmarkCandidates?.data?.data?.find(
      (item) => Number(item?.candidate?.id) === Number(candidateId)
    ) || null;

  const handleClick = (e, type, item) => {
    e.preventDefault();
    e.stopPropagation();

    setLoading(true);

    if (type === 1) {
      bookmarkCandidate({
        candidateUserId: candidateId,
      })
        .then((res) => {
          if (res?.data) {
            CustomSnackbar.success("Added to bookmark");
            dispatch(getBookmarkCandidates(customer?.id));
          }
        })
        .catch((err) => {
          apiErrorHandler(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      removeBookmarkCandidate(item.id)
        .then(() => {
          CustomSnackbar.success("Removed successfully.");
          dispatch(getBookmarkCandidates(customer?.id));
        })
        .catch((err) => {
          apiErrorHandler(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <>
      {/* ---------------- HEART ICON ---------------- */}

 {showIcon && (
  <>
    {loading ? (
      <div className="favorite-icon">
        <span className="bg-danger d-flex align-items-center justify-content-center">
          <Spinner size="sm" color="white" />
        </span>
      </div>
    ) : (
      <div
        className="favorite-icon"
        onClick={(e) =>
          handleClick(
            e,
            findBookmarkedCandidate ? 0 : 1,
            findBookmarkedCandidate
          )
        }
      >
        <span
          style={{ cursor: "pointer" }}
          className={findBookmarkedCandidate ? "bg-danger" : ""}
        >
          <i
            className={`uil uil-heart-alt fs-18 ${
              findBookmarkedCandidate ? "text-white" : ""
            }`}
          ></i>
        </span>
      </div>
    )}
  </>
)}

      {/* ---------------- TEXT BUTTON ---------------- */}

   {showText && (
  <div className="mt-4">
    {loading ? (
      <div className="card border-0 shadow-sm rounded-3">
        <div className="card-body py-2 d-flex align-items-center">
          <Spinner size="sm" color="primary" className="me-2" />
          <span className="text-muted">Updating bookmark...</span>
        </div>
      </div>
    ) : (
      <div
        className="card border shadow-sm rounded-3"
        style={{ cursor: "pointer" }}
        onClick={(e) =>
          handleClick(
            e,
            findBookmarkedCandidate ? 0 : 1,
            findBookmarkedCandidate
          )
        }
      >
        <div className="card-body py-3 px-4 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div
              className={`rounded-circle d-flex align-items-center justify-content-center me-3 ${
                findBookmarkedCandidate
                  ? "bg-soft-danger"
                  : "bg-soft-primary"
              }`}
              style={{ width: 45, height: 45 }}
            >
              <i
                className={`uil ${
                  findBookmarkedCandidate
                    ? "uil-heart text-danger"
                    : "uil-heart-alt text-primary"
                } fs-20`}
              ></i>
            </div>

            <div>
              <h6 className="mb-1 fw-bold">
                {findBookmarkedCandidate
                  ? "Remove Bookmark"
                  : "Add to Bookmark"}
              </h6>

              <small className="text-muted">
                {findBookmarkedCandidate
                  ? "This candidate is already in your bookmarks."
                  : "Save this candidate for quick access later."}
              </small>
            </div>
          </div>

          <i className="uil uil-angle-right-b fs-4 text-muted"></i>
        </div>
      </div>
    )}
  </div>
)}
    </>
  );
};

export default AddToBookmarkCandidate;
